const downloadFile = (url: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = 'roster-template.csv'; // Optional: Rename the downloaded file
  document.body.appendChild(a); // Append the element to the DOM
  a.click(); // Programmatically click the element to trigger the download
  document.body.removeChild(a);
}

export default downloadFile